import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function paySlipReducer() {
    return combineReducers({
        lckPrintPayListHdr: createItemReducer("PaySlip", "CalcKernelRep.LckPrintPayListNewLkHdr", false),
        lckPrintPayListHdrParams: createItemReducerParams("PaySlip", "CalcKernelRep.LckPrintPayListNewLkHdr"),
        lckPrintPayListTab: createItemReducer("PaySlip", "CalcKernelRep.LckPrintPayListNewLkTab", false),
        CalcPeriod_SelectOneNotLongCur: createItemReducer("PaySlip", "CalcPeriod.SelectOneNotLongCur", false),

/*
        CalcKernelRep_vckPayListSlavLK: createItemReducer("PaySlip", "CalcKernelRep.vckPayListSlavLK", false),
        CalcKernelRep_vckPayListSlavLKParams: createItemReducerParams("PaySlip", "CalcKernelRep.vckPayListSlavLK"),
*/
        CalcKernelRep_vckPayListSlavLkMain: createItemReducer("PaySlip", "CalcKernelRep.vckPayListSlavLkMain", false),
        CalcKernelRep_vckPayListSlavLkMainParams: createItemReducerParams("PaySlip", "CalcKernelRep.vckPayListSlavLkMain"),
        CalcKernelRep_vckPayListSlavLkTabMain: createItemReducer("PaySlip", "CalcKernelRep.vckPayListSlavLkTabMain", false),
        CalcKernelRep_vckPayListSlavLkTabMainParams: createItemReducerParams("PaySlip", "CalcKernelRep.vckPayListSlavLkTabMain"),
        /* Аливария */
        CalcKernelRep_LckPayListAlivariaLkMain: createItemReducer("PaySlip", "CalcKernelRep.LckPayListAlivariaLkMain", false),
        CalcKernelRep_LckPayListAlivariaLkMainParams: createItemReducerParams("PaySlip", "CalcKernelRep.LckPayListAlivariaLkMain"),
        CalcKernelRep_LckPayListAlivariaLkTab: createItemReducer("PaySlip", "CalcKernelRep.LckPayListAlivariaLkTab", false),
        CalcKernelRep_LckPayListAlivariaLkTabParams: createItemReducerParams("PaySlip", "CalcKernelRep.LckPayListAlivariaLkTab")
    });
}